import { useSelector } from 'react-redux'
import { getIsKiosk } from '../../selectors/menus'
import { getSpinnerShow, getSpinnerText } from '../Selectors'
import VNLoader from './VNLoader'

const VNSpinnerManager = () => {
  const isKiosk = useSelector(getIsKiosk)
  const show = useSelector(getSpinnerShow)
  const text = useSelector(getSpinnerText)

  if (!show) return null

  return <VNLoader transparent text={text} isKiosk={isKiosk} />
}

export default VNSpinnerManager
